module.exports = __webpack_public_path__ + "img/guide1.4fbf3db3.jpg";